module.exports = __webpack_public_path__ + "static/media/like.85c11eac.svg";